// extracted by css-extract-rspack-plugin
var _1 = "RatingIcon-m_godroll-Ix_a_6E_";
var _2 = "RatingIcon-m_trashlist-hoMvUHFR";
export { _1 as "godroll", _2 as "trashlist" }
